import React, { useReducer, useEffect, Fragment, Suspense, lazy } from "react";
import "./App.css";
// import Loader from "./loader/Loader";
import { LandingPageService } from "./Service/LandingPageService";
import { getUserLanguage, getUserCountry, getUserConfigs, getMatchedItemFromResponse, ValidateUTMSource } from './helper';


const HeaderBarComponent = lazy(() => import("./header/HeaderBar" /* b */))
const HeaderLogoComponent = lazy(() => import("./header/HeaderLogo" /* l */))
const EnterNumberComponent = lazy(() => import("./EnterNumber/EnterNumber" /* n */))
const EnterPinComponent = lazy(() => import("./EnterPin/EnterPin" /* pn */))
const PriceTextComponent = lazy(() => import("./price-text/PriceText" /* pr */))

const initialState = {
  lang: "en",
  error: "",
  loading: false,
  number: "",
  last: "",
  cnic: "",
  pin: "",
  isHE: false,
  loadingHE: false,
  ip: "",
  pinSent: false,
  isHttps: false,
  country: undefined,
  telco: undefined,
  headerClickCount: 0,
  flow: "",
  token: "",
  utmValidationStatus: false,
  configuration: undefined,
  services: [],
  showEPLoaderModal: true,
  config: undefined,
  userTelco: undefined
}

function reducer(state, action) {
  return { ...state, [action.type]: action.payload }
}

function App() {
  const [state, dispatch] = useReducer(reducer, initialState);
  
  useEffect(() => {
    if (window.location.protocol === 'https' && !state.isHttps) {
      dispatch({ type: "isHttps", payload: true });
    }
    if (!ValidateUTMSource()) {
      dispatch({ type: "utmValidationStatus", payload: false });
      console.error("Error UTM VALIDATION FAILS")
      return;
    }
    console.log("this is state: " + state.showEPLoaderModal);
    dispatch({ type: "utmValidationStatus", payload: true });
    dispatch({ type: "country", payload: getUserCountry() });
    dispatch({ type: "config", payload: getUserConfigs() });
    //dispatch({ type: "telco", payload: getUserTelco() });
    dispatch({ type: "lang", payload: getUserLanguage() });
  }, [state.isHttps]);

  useEffect(() => {
    if (state.config) 
      (async function () {
        console.log("state.config: " + state.config)
        let config = await import("./Configuration/" + state.config);
        console.log("config file: " + config)
        if (config) {
          config = config.default[state.config];
          let validServices = config.getValidServices();
          // console.log(validServices);
          dispatch({ type: "configuration", payload: config });
          dispatch({ type: "services", payload: validServices });
          dispatch({ type: "loadingHE", payload: true });
          if(state.config==="pinFlow"){
          config.services.filter(service => validServices.includes(service.SERVICE_ID)).forEach((telco, i) => {
            if (telco.header) {
              console.log("telco.header: " + telco.header);
              dispatch({ type: "isHE", payload: false });
            }
          });
        }
        else {
          config.services.filter(service => validServices.includes(service.SERVICE_ID)).forEach((telco, i) => {
            if (telco.header) {
              console.log("telco.header: " + telco.header);
              LandingPageService.getNumberFromHeader(telco.header.getNumberUrl(), i).then((NFHResponse) => {
                if (NFHResponse.status === 1) {
                  dispatch({ type: "isHE", payload: true });
                  dispatch({ type: "number", payload: NFHResponse.data.msisdn });
                  dispatch({ type: "flow", payload: NFHResponse.data.flow });
                  dispatch({ type: "token", payload: NFHResponse.data.token });
                  window.gtag("event", "header_found", { ...NFHResponse });
                  
                  dispatch({ type: "telco", payload: telco });
                }
                dispatch({ type: "loadingHE", payload: false });
              }, () => {
                dispatch({ type: "loadingHE", payload: false });
              }
              );
            }
          });
        }
        }
      })();
  }, [state.config]);

  useEffect(() => {
    if (state.pinSent && state.telco && state.telco.pinFlow.isMcpEnabled) {
      //load MCP script here
      let script = state.telco.pinFlow.mcpScript();
      eval(script);
    }
    // else
    //   console.log("else load MCP SCRIPT");
  }, [state.telco, state.pinSent]);
  
  const emptyView = () => {
    return <div></div>
  }
  const closeLoader = () => {
    console.log("this is in closeLoader method");
    state.showEPLoaderModal = false;
    //showEPLoaderModal= false;
  }
  
  const mainView = () => {
    return (
      <div className="container">
        <div className={state.lang === "en" ? "en" : "ur"}>
          <Fragment>
            <div>
              <Suspense fallback={<></>}>
                <HeaderBarComponent dispatch={dispatch} lang={state.lang} languages={state.configuration ? state.configuration.languages : []} />
              </Suspense>
            </div>
            <div style={{ minHeight: "22%" }}>
              <Suspense fallback={<></>}>
                <HeaderLogoComponent lang={state.lang} img={state.configuration? state.configuration.getLogo(): ""} config={state.config} configure={state.configuration? state.configuration: ""}/>
              </Suspense>
            </div>
            <div>
              <Suspense fallback={<></>}>
                <section>
                  {!state.pinSent && (
                    <EnterNumberComponent
                      state={state}
                      dispatch={dispatch}
                    />
                  )}
                  {state.pinSent && (
                    <EnterPinComponent state={state} dispatch={dispatch} />
                  )}

                </section>
              </Suspense>
            </div>
            <div>
              <Suspense fallback={<></>}>
                <PriceTextComponent text={state.configuration ? (state.configuration.price_points[state.lang] ? state.configuration.price_points[state.lang]() : "") : ""} />
              </Suspense>
            </div>
          </Fragment>
        </div>
      </div>
    );
  };

  return (
    <>
      {state.config && state.config.toLowerCase() === "telenorpk" 
        ? 
        <script>
        {
          `<!-- Global site tag (gtag.js) - Google Ads: 10775311030 For Telenor --> 
          <script async src="https://www.googletagmanager.com/gtag/js?id=AW-10775311030">
          </script> 
          <script> 
            window.dataLayer = window.dataLayer || [];
            function gtag() {
              dataLayer.push(arguments);
            } 
            gtag('js', new Date()); 
            gtag('config', 'AW-10775311030'); 
          </script>
        
          <!-- Facebook Pixel Code -->
        <script>
          !function(f,b,e,v,n,t,s)
          {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
          n.callMethod.apply(n,arguments):n.queue.push(arguments)};
          if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
          n.queue=[];t=b.createElement(e);t.async=!0;
          t.src=v;s=b.getElementsByTagName(e)[0];
          s.parentNode.insertBefore(t,s)}(window,document,'script',
          'https://connect.facebook.net/en_US/fbevents.js');
          fbq('init', '832045020813986'); 
          fbq('track', 'PageView');
          
          </script>
          <noscript>
          <img height="1" width="1" 
          src="https://www.facebook.com/tr?id=832045020813986&ev=PageView
          &noscript=1"/>
          </noscript>
          <!-- End Facebook Pixel Code -->
        
        <!-- Event snippet for Subscribe_December2021 conversion page In your html page, add the snippet and call gtag_report_conversion when someone clicks on the chosen link or button. --> 
        <script> function telenor_gtag_report_conversion(url) { var callback = function () { if (typeof(url) != 'undefined') { window.location = url; } }; gtag('event', 'conversion', { 'send_to': 'AW-10775311030/HP49CKWJiJMDELbliJIo', 'event_callback': callback }); return false; } </script>`
        }
        </script>
        : 
        ""
      }
      {state.isHttps ? emptyView() : state.utmValidationStatus ? mainView() : emptyView()}
    </>
  );
}

export default App;
